import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { ReactComponent as DashboardIcon } from "../../../Assets/svgs/dashboardImg.svg";
import { callLogEvent } from "../../Util";
import { CircularProgress } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  root: {
    // Make card flexible so it can wrap inside its container instead of overflowing
    boxSizing: "border-box",
    minWidth: 200,
    maxWidth: 400,
    border: "1px solid #D7E5F8",
    boxShadow: "rgba(0, 92, 188, 0.08) 0px 5px 15px",
  },
  content: {
    padding: '8px'
  },
  title: {
    display: "flex",
    fontSize: "14px",
    color: "rgba(0, 28, 74, 1)",
    fontWeight: "bold",
    // padding: "5px 0px",
    justifyContent: "space-between",
    alignItems: "center"
  },
  description: {
    color: "#616161",
    fontSize: "10px",
    fontStyle: "normal",
  },
  buttonFile: {
    border: "1.5px solid #005CBC",
    borderRadius: "24px",
    padding: "4px 15px",
    textTransform: "capitalize",
    float: "right",
    color: " #005CBC",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      minHeight: "36px",
      fontSize: "12px",
      whiteSpace: "nowrap",
    },
  },
  disableButtonFile: {
    border: "1.5px solid #9a9b9c",
    borderRadius: "24px",
    padding: "4px 15px",
    textTransform: "capitalize",
    float: "right",
    color: " #005CBC",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: "bold",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      minHeight: "36px",
      whiteSpace: "nowrap",
    },
  },
  btnAction: {
    padding: "0px 24px 10px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "8px",
    flexWrap: "nowrap",
    [theme.breakpoints.down("sm")]: {
      padding: "0px 12px 12px",
      flexDirection: "column",
      alignItems: "end",
      gap: "10px",
    },
  },
  actionControl: {
    width: "auto",
    flexShrink: 0,
    [theme.breakpoints.down("sm")]: {
      width: "114px",
      maxWidth: "114px",
    },
  },
  dropdownWrap: {
    marginRight: "8px",
    display: "flex",
    alignItems: "center",

    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
      justifyContent: "center",
    },
  },
  dropdown: {
    border: "1.5px solid #005CBC",
    borderRadius: "24px",
    fontSize: "10px",
    fontWeight: "bold",
    color: "#005CBC",
    padding: "2px 6px",
    height: "24px",
    minWidth: "110px",
    outline: "none",
    backgroundColor: "#fff",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      minWidth: 0,
      height: "36px",
      fontSize: "12px",
      padding: "6px 12px",
    },
  },
}));

const SimpleCard = ({ handleDashboard, handleSummary, data, onPage, hidden = false, loading = false, loadingTitle }: any) => {
  const classes = useStyles();
  const [selectedMarket, setSelectedMarket] = React.useState("UAE MT");
  const normalizedCardIdentity = `${data?.title || ""} ${data?.display_name || ""}`
    .toLowerCase()
    .trim();
  const isMiddleEastCard =
    normalizedCardIdentity.includes("middle east") ||
    normalizedCardIdentity.includes("ai for bi") ||
    normalizedCardIdentity.includes("uae mt");


  const handleDashboardClick = (event: any, title: string) => {
    handleDashboard && handleDashboard(event);
    callLogEvent(
      "CLICKED_ON_" +
      onPage!.toUpperCase().trim().replaceAll(" ", "_") +
      "_" +
      title.toUpperCase().trim().replaceAll(" ", "_") +
      "_VIEW_PBI_DASHBOARD",
      "clicked on view PBI Dashboard for " + title
    );
  };
  const handleSummaryClick = (event: any, title: string) => {
    if (isMiddleEastCard) {
      localStorage.setItem("SelectedMarket", selectedMarket);
    }
    if (title === "R AND D") {
      localStorage.setItem("DataSource", 'r_and_d');
    }
    if (title === "FLNA Topline") {
      localStorage.setItem("DataSource", 'topline');
    }
    if (title === "UAE MT") {
      localStorage.setItem("DataSource", 'uae_mt');
    }
    handleSummary && handleSummary(event);
    callLogEvent(
      "CLICKED_ON_NEW_DAILOG_" +
      title.toUpperCase().trim().replaceAll(" ", "_") +
      "_VIEW_SUMMARY_BUTTON",
      "clicked on view summary for " + title
    );
  };
  return (
    <Card className={classes.root} style={onPage === 'NEW_DAILOG' ? { width: '40%' } : {}} hidden={hidden}>
      <CardContent className={classes.content}>
        <Typography variant="h5" component="h2" className={classes.title}>
          {data.display_name}{" "}
          <DashboardIcon
            className={data.is_active ? "cursor-pointer" : "disable"}
            onClick={(event) => {
              handleDashboardClick(event, data.title);
            }}
            name={data.title + "_icon"}
          />
        </Typography>
        <Typography color="textSecondary"></Typography>
        <Typography component="p" className={classes.description}>
          {data.short_description}
        </Typography>
      </CardContent>
      <CardActions className={classes.btnAction}>
        {isMiddleEastCard && (
          <div className={`${classes.dropdownWrap} ${classes.actionControl}`}>
            <select
              className={classes.dropdown}
              value={selectedMarket}
              onChange={(event) => setSelectedMarket(event.target.value)}
              aria-label="Select market"
            >
              <option value="UAE MT">UAE MT</option>
              <option value="KSA MT">KSA MT</option>
            </select>
          </div>
        )}
        <div className={isMiddleEastCard ? classes.actionControl : undefined}>
          <Button
            size="small"
            className={
              data.is_active ? classes.buttonFile : classes.disableButtonFile
            }
            disabled={!data.is_active || loading}
            onClick={(event) => {
              handleSummaryClick(event, data.title);
            }}
          >
            {loading && data.title === loadingTitle && (
              <CircularProgress
                size={20}
                disableShrink
                sx={{
                  color: "green",
                  padding: "5px",
                  margin: "-10px 0px -10px -2px ",
                }}
              />
            )}
            {data.title === "R AND D" || data.title === "SpendWise"
              ? "ask Question"
              : "View Summary"}
          </Button>
        </div>
      </CardActions>

    </Card>
  );
};

export default SimpleCard;
